<template>
  <div
    @click="$store.commit('modals/OPEN_ORG_PRODUCT_COUPON_LIST_MODAL', false)"
    class="py-3 md-pd flex items-center w-full h-full justify-center add-product__modal__container"
  >
    <section
      @click.stop
      class="w-full md:w-1/2 lg:w-1/3 p-4 add-product__modal__container__chat relative"
    >
      <div
        @click="
          $store.commit('modals/OPEN_ORG_PRODUCT_COUPON_LIST_MODAL', false)
        "
        class="flex absolute items-center justify-center cross-icon cursor-pointer z-20"
      >
        X
      </div>

      <div class="w-full flex flex-col gap-y-4">
        <div>
          <p class="text-sm text-left coupons-text">
            Comma and Enter separated redemption codes
          </p>
          <vs-input
            v-model="coupon"
            placeholder="Redemption Code"
            class="w-full"
            @keyup.enter="addCouponCode()"
          />
        </div>
        <section id="coupon-codes" class="flex flex-wrap gap-2">
          <button
            v-for="(couponCode, key) in couponCodes"
            :key="key"
            class="coupon__display px-3"
            @click="removeCouponCode(couponCode)"
          >
            {{ couponCode }}
          </button>
        </section>
        <vs-button @click="saveCouponCodes()">Save Redemption Codes</vs-button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "AddProductTypeModal",
  data() {
    return {
      coupon: "",
      couponCodes: [],
    };
  },
  props: {},
  computed: {
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    orgProductCouponCodes() {
      return this.$store.state.market.orgProductCouponCodes;
    },
  },
  watch: {
    orgData: {
      handler(newVal, oldVal) {
        if (
          newVal !== oldVal &&
          Object.keys(oldVal).length > 0 &&
          this.orgAssignments &&
          this.orgAssignments.length === 0
        ) {
          this.orgId = newVal._id;
        }
      },
      deep: true,
      setImmediate: true,
    },
  },
  created() {},
  methods: {
    addCouponCode() {
      let _coupons = this.coupon;
      if (_coupons.includes(",") || _coupons.includes("\n")) {
        _coupons = _coupons.split(/,|\n/);
        _coupons.forEach((coupon) => {
          if (!this.couponCodes.includes(coupon)) {
            this.couponCodes.push(coupon);
          }
        });
      } else {
        if (!this.couponCodes.includes(_coupons)) {
          this.couponCodes.push(_coupons);
        }
      }
    },
    removeCouponCode(couponCode) {
      const index = this.couponCodes.indexOf(couponCode);
      if (index > -1) {
        this.couponCodes.splice(index, 1);
      }
    },
    saveCouponCodes() {
      this.$store.commit("market/ORG_PRODUCT_COUPONS", this.couponCodes);
      this.$store.commit("modals/OPEN_ORG_PRODUCT_COUPON_LIST_MODAL", false);
    },
  },
  beforeMount() {
    this.couponCodes = [...this.orgProductCouponCodes];
  },
};
</script>

<style lang="scss" scoped>
.coupon__display {
  background-color: rgb(212, 212, 212);
  border-radius: 20px;
}
.cross-icon {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  top: 0;
  font-size: 1.5em;
  padding: 0.5em;
  border-radius: 50%;
  height: 2em;
  width: 2em;
  top: -0.5em;
  right: -0.5em;
  transition: all 0.23s ease 0.1s;
  transform: translate(8px, -2px);
  font-family: "Montserrat", Helvetica, Arial, serif;
  background: #fffffffa;
  // For hover effect of close btn
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    outline: none;
    transform: translate(5px, 3px);
    box-shadow: none;
  }
}
.skeleton {
  position: relative;
  margin: 2em 0;
  padding: 10em 0;
  border-radius: 10px;
  background: rgb(128, 128, 128);
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
.b-dropdown ::v-deep .dropdown-toggle {
  white-space: normal;
}

.add-product__modal {
  &__container {
    background: #0000006a;
    backdrop-filter: blur(5px);
    position: fixed !important;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 100000;
    &__chat {
      width: 35%;
      border-radius: 10px;
      background: #fff;
      .text {
        color: #1c1c1e;
      }
    }

    .vs-tooltip {
      z-index: 5200000;
    }
    .card {
      background: #ffffff;
      box-shadow: 6px 6px 29px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
    }
    .validate-btn {
      font-size: 1.2em;
      background: grey;
      color: #fff;
      border-radius: 10px;
    }
    .validate-icon {
      filter: invert(91%) sepia(34%) saturate(1988%) hue-rotate(321deg)
        brightness(99%) contrast(92%);
    }
    .choose-skill__chat {
      width: 25%;
      max-height: 27.5em;
      height: auto;
      // top: 17.5%;
    }

    .choose-skill {
      &__avatar {
        // width: 100%;
      }
      &__btns {
        .btn {
          padding: 1em;
          background-color: #82868b;
          color: #ffffff;
          width: 55%;
        }
      }
    }

    .overflow-container {
      max-height: 25em;
      overflow-y: scroll;
    }
  }
}

@media only screen and (max-width: 1400px) {
  .add-product__modal {
    &__container {
      .choose-skill {
        &__btns {
          .btn {
            width: 70%;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .add-product__modal {
    &__container {
      .choose-skill {
        &__chat {
          right: 2.75em;
          width: 32%;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .add-product__modal {
    &__container {
      &__chat {
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .add-product__modal {
    &__container {
      .choose-skill {
        &__chat {
          width: 50%;
          max-height: 75%;
          height: auto;
        }
      }
    }
  }
}

@media only screen and (max-width: 660px) {
  .add-product__modal {
    &__container {
      // &__chat {
      //   width: 95%;
      //   height: 75%;
      //   top: 3.5em;
      // }

      .choose-skill__chat {
        width: 95%;
      }
      .choose-skill {
        &__avatar {
          img {
            width: 25%;
          }
        }
      }
    }
  }
}
</style>
